import module from 'prestamosExternos/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('prestamosExternos', {
    url: '/prestamos-externos?{fecha_inicial:date}&{fecha_final:date}&{concepto_id:int}&{estatus:int}',
    data: {title: 'Préstamos externos'},
    params: {
      fecha_inicial: {value: null},
      fecha_final: {value: null},
      concepto_id: {value: null},
      estatus: {value: 1, squash: true},
    },
    resolve: {
      fechaInicial: ($stateParams) => $stateParams.fecha_inicial,
      fechaFinal: ($stateParams) => $stateParams.fecha_final,
      conceptoId: ($stateParams) => $stateParams.concepto_id,
      estatus: ($stateParams) => $stateParams.estatus,
    },
    reloadOnSearch: false,
    template: '<prestamos-externos-lista fecha-inicial="fechaInicial" fecha-final="fechaFinal" concepto-id="conceptoId" estatus="estatus"/>',
    controller: ($scope, fechaInicial, fechaFinal, conceptoId, estatus) => {
      $scope.fechaInicial = fechaInicial
      $scope.fechaFinal = fechaFinal
      $scope.conceptoId = conceptoId
      $scope.estatus = estatus
    },
  })
})



// WEBPACK FOOTER //
// ./src/prestamosExternos/routes/prestamosExternos.js